import IconAccount24 from '../Icon/IconAccount24.vue';
import IconAccountConnected24 from '../Icon/IconAccountConnected24.vue';
import IconComponent from '../Icon/IconComponent.vue';

export default {
  name: 'NavButton',
  components: {
    IconAccount24,
    IconAccountConnected24,
    IconComponent
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: true,
      required: true
    },
    isConnected: {
      type: Boolean,
      default: false,
      required: true
    },
    navButtonLabel: {
      type: String,
      default: '',
    },
    ariaLabelNavButton: {
      type: String,
      default: '',
    },
    dfltcloseA11y: {
      type: String,
      default: '',
    },
  },
  computed : {
    componentIs() {
      return this.isConnected ? 'IconAccountConnected24' : 'IconAccount24';
    },
    ariaLabelLoginButton() {
      return this.isOpen ? this.dfltcloseA11y : this.ariaLabelNavButton;
    }
  },
  methods: {
    sendClick() {
      this.$emit('toggleLoginNav', null);
    }
  }
};
